/* gw: product page revamp (Figma 456:2187 / 456:2881)
 * Keeps two server-rendered pieces in sync with the selected variant, using BoosterTheme's
 * 'booster:variant:select' event (assets/booster.js selectSwatch). No other behaviour is changed.
 *  - the free-shipping note [data-gw-ship] (snippets/block__product-page--price.liquid): shown while the
 *    variant price reaches data-gw-ship-min (cents);
 *  - the Save badge [data-gw-badge] (snippets/gallery--default.liquid): shown only while compare-at > price;
 *  - the price's sale colour [data-gw-sale] (snippets/block__product-page--price.liquid): red only while compare-at > price.
 */
(() => {
  'use strict';

  const formatMoney = (cents) => {
    try {
      return BoosterTheme.cfx.formatMoney(cents, BoosterTheme.cfx.getFormat());
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const syncShipNote = (productId, price) => {
    document.querySelectorAll('[data-gw-ship="' + productId + '"]').forEach((note) => {
      const min = parseInt(note.dataset.gwShipMin, 10) || 0;
      note.hidden = price < min;
    });
  };

  const syncBadge = (productId, price, compareAt) => {
    const saved = Number(compareAt) - price;
    document.querySelectorAll('[data-gw-sale-product="' + productId + '"]').forEach((holder) => {
      holder.dataset.gwSale = saved > 0 ? 'true' : 'false';
    });
    document.querySelectorAll('[data-gw-badge="' + productId + '"]').forEach((badge) => {
      if (saved > 0) {
        badge.textContent = formatMoney(saved);
        badge.classList.remove('hide');
      } else {
        badge.classList.add('hide');
      }
    });
  };

  const init = () => {
    if (typeof BoosterTheme === 'undefined' || !BoosterTheme.events) return;
    BoosterTheme.events.on('booster:variant:select', (params) => {
      if (!params || !params.product || !params.selectedVariant) return;
      const price = Number(params.selectedVariant.price_raw);
      if (Number.isNaN(price)) return;
      syncShipNote(params.product.id, price);
      syncBadge(params.product.id, price, params.selectedVariant.sale_raw);
    });
  };

  init();
})();
